export default {
  component: () => import('./pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        content: 'View listings in your shop that are missing key components or contain potential issues.',
        name: 'description',
      },
      {
        page_slug: 'health-check',
      },
      {
        name: "google",
        content: "notranslate",
      },
    ],
    requiresAuth: true,
    title: 'eRank — Health Check',
  },
  name: 'health-check',
  path: '/health-check',
};
